
export default [
	{
		'name': 'Нужно сделать',
		'id': 'row-1',
		'cards': [
			{
				'title': 'Тестовое задание на React',
				'id': 'task-1',
				'text': 'Детальное описание'
			},
			{
				'title': 'Тестовое 2',
				'id': 'task-2',
				'text': 'Детальное описание'
			},
			{
				'title': 'Тестовое 3',
				'id': 'task-3',
				'text': 'Детальное описание'
			}
		]
	},
	{
		'name': 'В процессе',
		'id': 'row-2',
		'cards': [
			{
				'title': 'Тестовое 4',
				'id': 'task-4',
				'text': 'Детальное описание',
			},
		]
	},
	{
		'name': 'Готово',
		'id': 'row-3',
		'cards': []
	}
]


// WEBPACK FOOTER //
// ./src/data/columns.js